import React, { useEffect } from 'react';
import { ICON_SPRITE, IconName } from './iconSprite';

/** Дизайн системийн 24px stroke icon — sprite-ийн <symbol id="i-name">-ийг ашиглана. */
export default function Icon({ name, size = 20, className, style, label }: { name: IconName; size?: number; className?: string; style?: React.CSSProperties; label?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
      className={className} style={{ flexShrink: 0, ...style }} aria-hidden={label ? undefined : true} role={label ? 'img' : undefined} aria-label={label}>
      <use href={`#i-${name}`} />
    </svg>
  );
}

/** Sprite-ийг body-д нэг удаа inject хийнэ (App root-д нэг л удаа render). */
export function IconSprite() {
  useEffect(() => {
    if (document.getElementById('sh-icon-sprite')) return;
    const wrap = document.createElement('div');
    wrap.id = 'sh-icon-sprite'; wrap.style.display = 'none'; wrap.innerHTML = ICON_SPRITE;
    document.body.prepend(wrap);
  }, []);
  return null;
}
